import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueContentPlaceholders from 'vue-content-placeholders'
import checkView from 'vue-check-view'
import VueMeta from 'vue-meta'
import VueTippy from "vue-tippy"

import '@/assets/css/tailwind.css';
import '@/assets/css/nprogress.css';
import '@/directives/closeable.js';

Vue.use(VueContentPlaceholders)
Vue.use(checkView)
Vue.use(VueTippy)
Vue.use(VueMeta)

import './store/subscribers';

Vue.config.productionTip = true

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

export default vm;

